import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { FaqEntryResource } from '../interfaces/faq-entry-resource';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  /**
   * use the AWS API to load the FAQs
   * @deprecated
   */
  usesFAQ: boolean = false;
  /**
   * 
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {

  }
  /**
   * Get the FAQs
   * @returns 
   */
  getFAQs(): Observable<any> {
    if (this.usesFAQ) {
      return this.http.get<any[]>(`https://myfoy05i0l.execute-api.eu-central-1.amazonaws.com/proto/faq`)
    } else {
      return this.environment.apiV1$.pipe(
        switchMap(url => this.http.get(`${url}/selfservices/faq`, {})
        )
      )
    }
  }
  /**
   * Create a FAQ
   * @param faq 
   * @returns 
   */
  createFAQ(faq: FaqEntryResource) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/selfservices/faq`, faq)
      )
    )
  }
  /**
   * Delete a FAQ
   * @param faq 
   * @returns 
   */
  deleteFAQ(faq: FaqEntryResource) {
    if (this.usesFAQ) {
      return this.http.delete(`https://myfoy05i0l.execute-api.eu-central-1.amazonaws.com/proto/faq`)
    } else {
      return this.environment.apiV1$.pipe(
        switchMap(url => this.http.delete(`${url}/selfservices/faq/${faq.publicId}`)
        )
      )
    }
  }
  /**
   * Get a FAQ by ID
   * @param faqID 
   * @returns 
   */
  getFAQ(faqID) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/selfservices/faq/${faqID}`)
      )
    )
  }
  /**
   * Edit a FAQ
   * @param faq 
   * @returns 
   */
  editFAQ(faq: FaqEntryResource) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.put(`${url}/selfservices/faq/${faq.publicId}`, faq)
      )
    )
  }
}